export const paramsToUrl = (object = {}, picks = ["pageNum", "pageSize"]) => {
  if (typeof object === "object") {
    let str = Object.keys(object)
      .filter(i => picks.includes(i))
      .map(key => `${key}=${object[key]}`)
      .join("&");
    return `?` + str;
  } else {
    return "";
  }
};
